var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-id":"OwlCarousel"}},[_c('span',{attrs:{"id":_vm.prevHandler}},[_vm._t("prev")],2),_vm._v(" "),_c('div',{class:['owl-carousel', 'owl-theme'],attrs:{"id":_vm.elementHandle}},[_vm._t("default")],2),_vm._v(" "),_c('span',{attrs:{"id":_vm.nextHandler}},[_vm._t("next")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad95c76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generals/OwlCarousel.vue
// module id = null
// module chunks = 